/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".download-row[_ngcontent-%COMP%]{display:flex;align-items:center;padding:6px 0}.download-row[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid #ececec}.download-name[_ngcontent-%COMP%]{flex:1 1 auto;word-break:break-word}.download-btn[_ngcontent-%COMP%], .download-spinner[_ngcontent-%COMP%]{flex:0 0 auto}.download-all-spinner[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}"];
export { styles as styles };
